module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq694-3a7b4a86d0134fc99cbc7794a7254fd9.jpg";